<template>
  <div class="container">
    <div
      v-show="isTournamentButtonVisible"
      role="button"
      class="container__tournament"
      :style="{ 'background-color': getModal ? '#132739' : 'white' }"
      @click="onClickTournament"
    >
      <template v-if="!getModal">
        <img class="logo" :src="imgLiga" alt="" />
        <div>{{ getTournamentsNameSelected }}</div>
      </template>
      <template v-else>
        <div class="close-text">
          CERRAR
        </div>
        <div class="close-icon">
          <img src="https://golstatsimages.blob.core.windows.net/todoelfut/icn_close.png" />
        </div>
      </template>
    </div>
    <div
      role="button"
      class="container__team"
      :class="{ 'no-dashboard': !showDashboard, 'is-team-only': !isTournamentButtonVisible }"
      @click="onClickTeam"
    >
      <img class="logo" :src="teamLogo" alt="" />
      <div>
        {{ teamText }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';

export default {
  name: 'NavBarTournamentButtonMobile',
  computed: {
    ...mapGetters('loginGeneral', [
      'getModal',
      'getUser',
      'getTournaments',
      'getSeasons',
      'getTournamentSelected',
      'getSeasonSelected',
      'getTournamentsNameSelected',
      'showDashboard',
    ]),
    isTournamentButtonVisible() {
      return !['players', 'player', 'team'].includes(this.$route.name);
    },
    imgLiga() {
      if (this.getTournamentSelected === 33) {
        return 'https://golstatsimages.blob.core.windows.net/todoelfut/' + this.getSeasonSelected + '.png';
      } else {
        return 'https://golstatsimages.blob.core.windows.net/todoelfut/' + this.getTournamentSelected + '.png';
      }
    },
    imgLogo() {
      if (this.getUser.player !== 0) {
        return 'https://golstatsimages.blob.core.windows.net/players-profile/' + this.getUser.player + '.png';
      } else {
        return 'https://golstatsimages.blob.core.windows.net/teams-80/' + this.getUser.team + '.png';
      }
    },
    hasActiveTime() {
      return false; //this.getUser.active_time === 1;
    },
    isPlayer() {
      return this.getUser.player !== 0;
    },
    teamLogo() {
      return this.hasActiveTime ? 'https://golstatsimages.blob.core.windows.net/todoelfut/icn_tiempo_activo.png' : this.imgLogo;
    },
    teamText() {
      return this.hasActiveTime ? 'Tiempo efectivo' : this.isPlayer ? 'Mi perfil' : 'Mi equipo';
    },
  },
  methods: {
    ...mapMutations('loginGeneral', ['setModal']),
    ...mapActions('loginGeneral', [
      'storeTournamentSelected',
      'storeSeasonSelected',
      'storeTournamentNameSelected',
      'storeSeasonNameSelected',
    ]),
    onClickTournament() {
      this.setModal(!this.getModal);
    },
    onClickTeam() {
      this.setModal(false);
      if (this.hasActiveTime) {
        this.$router.push(`/activetime`);
      } else {
        if (!this.showDashboard) {
          return;
        }
        if (this.getUser.player !== 0) {
          if (
            Object.values(this.getUser.related_seasons).indexOf(this.getSeasonSelected) > -1 ||
            this.getSeasonSelected === this.getUser.season
          ) {
            this.$router.push({
              name: 'player',
              params: {
                seasonId: this.getSeasonSelected,
                playerId: this.getUser.player,
              },
              query: {
                section: 'me',
              },
            });
          } else {
            this.storeTournamentSelected(this.getUser.tournament);
            this.storeTournamentNameSelected(this.getTournaments[this.getUser.tournament].name);
            this.storeSeasonNameSelected(
              this.getSeasons[this.getUser.tournament][Object.keys(this.getSeasons[this.getUser.tournament])[0]].name,
            );
            this.storeSeasonSelected(Object.keys(this.getSeasons[this.getUser.tournament])[0].slice(1));
            this.$router.push({
              name: 'player',
              params: {
                seasonId: this.getSeasonSelected,
                playerId: this.getUser.player,
              },
              query: {
                section: 'me',
              },
            });
            // this.$router.push(`playersAnalysis/` + this.getSeasonSelected + `/` + this.getUser.player);
          }
        } else {
          var torunamentSelect = this.getUser.tournament;
          if (this.getUser.type_system == 'seleccion') {
            if (this.getTournamentSelected != 33) {
              torunamentSelect = 33;
              const nowMillis = new Date().getTime();
              const qatarEnabledDayMillis = new Date('2022-11-21T03:59:00.000Z').getTime();
              this.storeTournamentSelected(torunamentSelect);
              this.storeTournamentNameSelected(this.getTournaments[torunamentSelect].name);
              this.storeSeasonNameSelected(
                this.getSeasons[torunamentSelect][
                  Object.keys(this.getSeasons[torunamentSelect])[nowMillis >= qatarEnabledDayMillis ? 0 : 1]
                ].name,
              );
              this.storeSeasonSelected(
                Object.keys(this.getSeasons[torunamentSelect])[nowMillis >= qatarEnabledDayMillis ? 0 : 1].slice(1),
              );
            }
          } else {
            this.storeTournamentSelected(torunamentSelect);
            this.storeTournamentNameSelected(this.getTournaments[torunamentSelect].name);
            this.storeSeasonNameSelected(
              this.getSeasons[torunamentSelect][Object.keys(this.getSeasons[torunamentSelect])[0]].name,
            );
            this.storeSeasonSelected(Object.keys(this.getSeasons[torunamentSelect])[0].slice(1));
          }
          setTimeout(() => {
            this.$router.push({
              name: 'team',
              params: {
                teamId: this.getUser.team,
              },
              query: {
                section: 'me',
              },
            });
            // this.$router.push(`teamsAnalysis/` + this.getUser.team);
          }, 200);
        }
      }
    },
  },
};
</script>

<style scoped lang="scss">
.container {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  column-gap: 16px;
  padding: 0 8px;

  &__tournament {
    z-index: 16;

    & > img.logo {
      height: 32px;
    }

    @media screen and (max-width: 320px) {
      & > img.logo {
        margin: 0 -5px;
        width: fit-content;
      }
    }
  }

  &__team {
    & > img.logo {
      margin: 0 5px;
      height: 32px;
    }
  }

  & > div {
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 10px;
    border: solid 1px #b7b7b7;
    font-family: Avenir-Demi, sans-serif;
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.42;
    letter-spacing: -0.12px;
    color: #132739;
    cursor: pointer;
    padding: 8px 10px;
    max-height: 4.16em;
    height: 4.16em;

    & > div {
      margin: 0 5px;
      white-space: pre;
    }
  }

  @media screen and (max-width: 390px) {
    padding: 0 2px;
    column-gap: 8px;
  }
}

.close-text {
  font-family: Avenir-Bold, sans-serif;
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.13;
  letter-spacing: normal;
  color: #fff;
}

.close-icon {
  height: 15px;
  width: 15px;

  & > img {
    height: 15px;
    width: 15px;
  }
}
.no-dashboard:hover {
  cursor: default !important;
  opacity: 1 !important;
}

.is-team-only {
  grid-column-start: 2;
  grid-column-end: 3;
}
</style>
